import React from "react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { positionAbbrev, sortPlayersByName } from "@/lib/playerConstants";

/**
 * Einheitliche Spielerauswahl für das gesamte Projekt.
 *
 * Verwendet im Spielervergleich und in der Wäsche-Auswahl.
 * Spieler werden automatisch alphabetisch nach Name sortiert.
 *
 * @param {string} value - aktuell gewählter Spieler-Id
 * @param {(id: string) => void} onChange
 * @param {Array} players - vollständige Spielerliste
 * @param {string} [disabledId] - eine zu deaktivierende Id (z. B. der andere Vergleichs-Spieler)
 * @param {string} [accent] - optionale Tailwind-Klasse für den Trigger
 * @param {string} [placeholder]
 * @param {string} [testId]
 * @param {boolean} [disabled]
 */
export default function PlayerSelect({
  value,
  onChange,
  players,
  disabledId,
  accent = "",
  placeholder = "Spieler wählen",
  testId,
  disabled = false,
}) {
  const sorted = sortPlayersByName(players || []);
  return (
    <Select value={value || undefined} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger
        className={"bg-zinc-900 border-zinc-800 h-12 rounded-md focus:ring-brand text-zinc-100 " + accent}
        data-testid={testId}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-zinc-900 border-zinc-800 text-zinc-100">
        {sorted.length === 0 ? (
          <div className="px-3 py-2 text-xs text-zinc-500 italic">Kein Spieler verfügbar</div>
        ) : (
          sorted.map((p) => (
            <SelectItem
              key={p.id}
              value={p.id}
              disabled={p.id === disabledId}
              data-testid={testId ? `${testId}-opt-${p.id}` : undefined}
            >
              {p.name} · {positionAbbrev(p.position)}
            </SelectItem>
          ))
        )}
      </SelectContent>
    </Select>
  );
}
